var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileviewtoggle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.401,
    height: 15.359,
    viewBox: "0 0 19.401 15.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered_2_",
    "data-name": "bars-staggered(2)",
    d: "M0,3.213A1.211,1.211,0,0,1,1.213,2H14.147a1.213,1.213,0,1,1,0,2.425H1.213A1.211,1.211,0,0,1,0,3.213ZM14.147,14.934H1.213a1.213,1.213,0,1,0,0,2.425H14.147a1.213,1.213,0,1,0,0-2.425Zm4.042-6.467H5.255a1.213,1.213,0,1,0,0,2.425H18.189a1.213,1.213,0,0,0,0-2.425Z",
    transform: "translate(0 -2)",
    fill: "#002970"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileviewtoggle);
export default __webpack_public_path__ + "static/media/mobileviewtoggle.f9e6129628a57af0692fcb67fe3ee20a.svg";
export { ForwardRef as ReactComponent };